
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar, LineChart, BarChart, BubbleChart } from '@/components'
import store from '../store'
import FetchWrapper from '@/classes/fetchWrapper'
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

@Component({
  components: {
    NavBar,
    LineChart,
    BarChart,
    BubbleChart
  }
})

// https://github.com/creativetimofficial/vue-black-dashboard/blob/master/vue.config.js

// https://www.appsloveworld.com/chartjs/100/14/vue-js-vue-chart-js-linear-gradient-background-fill-source-code

// stilying:
// https://www.chartjs.org/docs/latest/samples/advanced/linear-gradient.html
// https://www.chartjs.org/docs/latest/api/interfaces/CoreChartOptions.html
// https://www.chartjs.org/docs/latest/samples/line/styling.html

export default class StatsView extends Vue {
  data () {
    return {
      isLoading: false,
      datasetsGraph1: null,
      labelsGraph1: null,
      datasetsGraph2: [],
      labelsGraph2: [],
      cefrDataset: null,
      taskScores: [],
      speakingCredits: 0,
      writingCredits: 0,
      articleCredits: 0,
      chatmessageCredits: 0,
      videoCredits: 0,
      taskTemplateCredits: 0,
      assessmentTemplateCredits: 0,
      learningVectorCredits: 0,
      callCredits: 0,
      promoCodeCredits: 0,
      creditsExpiration: (new Date()).toLocaleDateString(),
      t2tCredits: 0,
      s2tCredits: 0,
      dailyExpirationCredits: (new Date()).toLocaleDateString(),
      isTutorOrAdmin: false

      // chartId: 'purple-line-chart',
      /* extraOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        responsive: true,
        tooltips: {
          backgroundColor: '#f5f5f5',
          titleFontColor: '#333',
          bodyFontColor: '#666',
          bodySpacing: 4,
          xPadding: 12,
          mode: 'nearest',
          intersect: 0,
          position: 'nearest'
        },
        scales: {
          yAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(29,140,248,0.0)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              suggestedMin: 60,
              suggestedMax: 125,
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }],

          xAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(225,78,202,0.1)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }]
        }
      },
      chartData: {
        labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        datasets: [{
          label: 'Data',
          fill: true,
          borderColor: '#42b883',
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#42b883',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#42b883',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: [80, 100, 70, 80, 120, 80]
        }]
      },
      gradientColors: ['rgba(76, 211, 150, 0.1)', 'rgba(53, 183, 125, 0)', 'rgba(119,52,169,0)'],
      gradientStops: [1, 0.2, 0] */
    }
  }

  mounted () {
    // this.getLastNewAndRepeatedUsedWords()
    this.roles = store.getters.getUserRoles
    this.isTutorOrAdmin = this.roles ? this.roles.includes('ADMIN') || this.roles.includes('TUTOR') : false
    this.getAcountCreditsInfo()
    this.getLastUsedWordsCounter()
    this.getLearningVectorHistsByLevel()
    this.getTaskScores()
    // this.$refs.myChart.updateGradients(this.chartData)
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async getAcountCreditsInfo () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getAcountCreditsInfo`))
      this.speakingCredits = resp.speakingCredits
      this.writingCredits = resp.writingCredits
      this.articleCredits = resp.articleCredits
      this.chatmessageCredits = resp.chatmessageCredits
      this.videoCredits = resp.videoCredits
      this.taskTemplateCredits = resp.taskTemplateCredits
      this.assessmentTemplateCredits = resp.assessmentTemplateCredits
      this.learningVectorCredits = resp.learningVectorCredits
      this.callCredits = resp.callCredits
      this.promoCodeCredits = resp.promoCodeCredits
      this.creditsExpiration = (new Date(resp.expirationCredits)).toLocaleDateString()
      this.t2tCredits = resp.t2tCredits
      this.s2tCredits = resp.s2tCredits
      this.dailyExpirationCredits = (new Date(resp.dailyExpirationCredits)).toLocaleDateString()
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Credits Information.',
        canCancel: false
      })
    }
  }

  async getLastNewAndRepeatedUsedWords () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getLastNewAndRepeatedUsedWords`))
      this.newWords = resp.newWords
      this.repeatedWords = resp.repeatedWords
      this.datasetsGraph2 = []
      this.datasetsGraph2.push({ data: [], label: 'New' })
      this.datasetsGraph2.push({ data: [], label: 'Repeated' })
      this.labelsGraph2 = []
      this.labelsGraph2.push([])
      var keys = Object.keys(this.newWords)
      keys.forEach(key => {
        this.datasetsGraph2[0].data.push(this.newWords[key])
        this.datasetsGraph2[1].data.push(this.repeatedWords[key])
        this.labelsGraph2[0].push(key.split('-')[2])
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get stats new and repeated.',
        canCancel: false
      })
    }
  }

  async getLastUsedWordsCounter () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getLastUsedWordsCounter`))
      this.readWords = resp.readWords
      this.writtenWords = resp.writtenWords
      this.listenedWords = resp.listenedWords
      this.spokenWords = resp.spokenWords
      this.datasetsGraph1 = []
      this.datasetsGraph1.push({ data: [], label: 'Read' })
      this.datasetsGraph1.push({ data: [], label: 'Written' })
      this.datasetsGraph1.push({ data: [], label: 'Listened' })
      this.datasetsGraph1.push({ data: [], label: 'Spoken' })
      this.labelsGraph1 = []
      this.labelsGraph1.push([])
      var keys = Object.keys(this.readWords)
      keys.forEach(key => {
        this.datasetsGraph1[0].data.push(this.readWords[key])
        this.datasetsGraph1[1].data.push(this.writtenWords[key])
        this.datasetsGraph1[2].data.push(this.listenedWords[key])
        this.datasetsGraph1[3].data.push(this.spokenWords[key])
        this.labelsGraph1[0].push(key.split('-')[2])
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get stats new and repeated.',
        canCancel: false
      })
    }
  }

  async getLearningVectorHistsByLevel () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getLearningVectorHistsByLevel`))
      var rightNow = new Date()
      var month = rightNow.getMonth() + 1
      var day = rightNow.getDate()
      this.cefrDataset = resp.map(e => {
        var temp = e.x.split('-')
        e.x = Number(temp[1]) === month ? Number(temp[2]) : Number(temp[1]) < month ? Number(temp[2]) - 31 : -1000
        return e
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get stats by level.',
        canCancel: false
      })
    }
  }

  async getTaskScores () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getTaskScores`))
      var rightNow = new Date()
      var month = rightNow.getMonth() + 1
      var day = rightNow.getDate()
      // this.taskScores = resp
      this.taskScores = resp.map(e => {
        var date = e.completedAt.split('T')[0]
        var temp = date.split('-')
        var x = Number(temp[1]) === month ? Number(temp[2]) : Number(temp[1]) < month ? Number(temp[2]) - 31 : -1000
        return {
          x,
          y: e.score,
          r: 10
        }
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task scores.',
        canCancel: false
      })
    }
  }

  learningVectorHistsBubbleyTicksCallback (value, index, ticks) {
    switch (value) {
      case 10:
        return '    A1'
      case 20:
        return 'A2'
      case 30:
        return 'B1'
      case 40:
        return 'B2'
      case 50:
        return 'C1'
      case 60:
        return 'C2'
    }
  }

  taskScoresBubbleyTicksCallback (value, index, ticks) {
    return `${value}%`
  }

  learningVectorHistsBubbleTooltipLabel (context) {
    var level = ''
    switch (context.parsed.y) {
      case 10:
        level = 'A1'
        break
      case 20:
        level = 'A2'
        break
      case 30:
        level = 'B1'
        break
      case 40:
        level = 'B2'
        break
      case 50:
        level = 'C1'
        break
      case 60:
        level = 'C2'
        break
    }
    var x = context.parsed.x < 0 ? 31 + context.parsed.x : context.parsed.x
    return `${level} - ${context.parsed._custom} on day ${x}`
  }

  taskScoresBubbleTooltipLabel (context) {
    var x = context.parsed.x < 0 ? 31 + context.parsed.x : context.parsed.x
    return `${context.parsed.y}% score - ${context.parsed._custom / 10} task on day ${x}`
  }
}
